import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { withTranslation } from 'react-i18next';

const styles = theme => ({
  button: {
    marginLeft: theme.spacing.unit,
  },
});

function ButtonValidation(props) {
	const {classes, activeStep, handleBack, steps, t} = props;
	// console.log(props);
	return (
		<Grid
		  container
		  direction="row"
		  justify="flex-end"
		  alignItems="center"
		>
		  <Button
		    disabled={activeStep === 0}
		    onClick={handleBack}
		    className={classes.button}
		    type="button"
		  >
		    {t('validation_button_back')}
		  </Button>
		  <Button
		    variant="contained"
		    color="primary"
		    className={classes.button}
		    type="submit"
		    // disabled={ props.invalid }
		  >
		    {activeStep === steps.length - 1 ? t('validation_button_end') : t('validation_button_next')}
		  </Button>
		</Grid>
	);
}


function ButtonReset(props) {
	const {classes, handleReset, handleBack, t} = props;
	// console.log(props);
	return (
		<Grid
		  container
		  direction="row"
		  justify="flex-end"
		  alignItems="center"
		>
		  <Button onClick={handleReset} className={classes.button}>
        {t('restart_button')}
      </Button>
		</Grid>
	);
}

ButtonValidation.propTypes = {
  classes: PropTypes.object.isRequired,
};

ButtonReset.propTypes = {
  classes: PropTypes.object.isRequired,
};

ButtonValidation =  withStyles(styles)(ButtonValidation);
ButtonReset = withStyles(styles)(withTranslation()(ButtonReset)); 

export default withTranslation()(ButtonValidation);
export {ButtonReset};

									